import { ResourceQuery } from './ResourceQuery';
import { IListFetcher } from '../fetchers/IListFetcher';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { ISharedWithMeContentInfo } from '../models/ISharedWithMeContentInfo';
import { Module } from '../Module';
import { GetSharedWithMeRequest } from '../ServerApi/requests/GetSharedWithMeRequest';
import { FetcherFactory } from '../services/FetcherFactory';

export class SharedWithMe {
  public static $inject = ['FetcherFactory'];

  private getSharedWithMeContentInfo: IListFetcher<ISharedWithMeContentInfo>;

  constructor(FetcherFactory: FetcherFactory) {
    this.getSharedWithMeContentInfo = FetcherFactory.getServerResourceFetcher(GetSharedWithMeRequest, ServerApiMapper.sharedWithMe);
  }

  public getSharedWithMe(): ResourceQuery<ISharedWithMeContentInfo> {
    return new ResourceQuery(this.getSharedWithMeContentInfo);
  }
}

Module.instance().service('SharedWithMe', SharedWithMe);
